import { render, staticRenderFns } from "./RequisicionesDepartamento.vue?vue&type=template&id=15870540&"
import script from "./RequisicionesDepartamento.vue?vue&type=script&lang=js&"
export * from "./RequisicionesDepartamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports